const generateRows = (data) =>
  data.map((device) => {
    let status = device['device status']
    if (device['device type'] !== 'gateway') {
      if (status === 'PROVISIONED') status = 'ASSIGNED'
      if (status === 'OFFLINE') status = 'UNASSIGNED'
    }
    return {
      id: device['device name'],
      deviceId: device['device name'],
      name: device['device label'] || device['device name'],
      type: device['device type'],
      status,
      date: new Date(device['last update']).toLocaleString(),
      warranty: new Date(device.warranty).toLocaleString(),
    }
  })

export default generateRows
